import { ViewModel,View, ObservableArray } from "binder"
import { ShowWindowMessage, UserMainWindowViewModel } from "src/common/userMainWindow/userMainWindow-viewModel";
import { RequestCloseWindowMessage, WindowContainerViewModel, WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import  { SendNotificationView } from "./sendNotification-view"

export class SendNotificationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'یادآوری';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        // this.refresh();
        this.SetAlarm();
        this.unrealPaymentPerDistrict = ObservableArray.create<UnrealPayment>();
    }
    GetDefaultView(): View <ViewModel> {
        return new SendNotificationView();
    }
    public getTypeId(): string {
        return "VM-EA8A5935-0001-4989-86BD-4236F87D5FBC"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set totalCashOnDeliveryInvoicesPrice(v: number) { this._totalCashOnDeliveryInvoicesPrice = v; } public get totalCashOnDeliveryInvoicesPrice(): number { return this._totalCashOnDeliveryInvoicesPrice;} private _totalCashOnDeliveryInvoicesPrice: number;
    public set totalCashOnDeliveryInvoicesAmount(v: number) { this._totalCashOnDeliveryInvoicesAmount = v; } public get totalCashOnDeliveryInvoicesAmount(): number { return this._totalCashOnDeliveryInvoicesAmount;} private _totalCashOnDeliveryInvoicesAmount: number;
    public set totalUnpaidPrice(v: number) { this._totalUnpaidPrice = v; } public get totalUnpaidPrice(): number { return this._totalUnpaidPrice;} private _totalUnpaidPrice: number;
    public set totalUnpaidAmount(v: number) { this._totalUnpaidAmount = v; } public get totalUnpaidAmount(): number { return this._totalUnpaidAmount;} private _totalUnpaidAmount: number;
    public set unpaidInvoice(v: number) { this._unpaidInvoice = v; } public get unpaidInvoice(): number { return this._unpaidInvoice;} private _unpaidInvoice: number;
    public set unrealPaymentPerDistrict(v: ObservableArray<UnrealPayment>) { this._unrealPaymentPerDistrict = v; } public get unrealPaymentPerDistrict(): ObservableArray<UnrealPayment> { return this._unrealPaymentPerDistrict;} private _unrealPaymentPerDistrict: ObservableArray<UnrealPayment>;
    public set shallShowUnrealPayments(v: boolean) { this._shallShowUnrealPayments = v; } public get shallShowUnrealPayments(): boolean { return this._shallShowUnrealPayments;} private _shallShowUnrealPayments: boolean;
    public set totalUnrealPaymentPrice(v: number) { this._totalUnrealPaymentPrice = v; } public get totalUnrealPaymentPrice(): number { return this._totalUnrealPaymentPrice;} private _totalUnrealPaymentPrice: number;
    
    async refresh(){
        try {
            // this.requestClose = () => {return false};
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/SellServices/GetRemainderReports',{
            });
            if (result.IsSuccessful==false) {
                throw 'Fault';
            }
            if (result.CanSale == false) {
                this.close();
            }
            this.totalCashOnDeliveryInvoicesPrice = result.TotalCashOnDeliveryInvoicesPrice;
            this.totalCashOnDeliveryInvoicesAmount = result.TotalCashOnDeliveryInvoicesAmount;
            this.totalUnpaidPrice = result.TotalUnpaidPrice;
            this.totalUnpaidAmount = result.TotalUnpaidAmount;
            this.unpaidInvoice = result.UnpaidInvoice;
            this.unrealPaymentPerDistrict.update(...result.UnrealAccountsPerDistrict.map(q => {
                let u = new UnrealPayment(this);
                u.districtName = q.DistrictName;
                u.unrealPaymentPrice = q.TotalPrice;
                return u;
            }));
            this.shallShowUnrealPayments = true;
            this.totalUnrealPaymentPrice = this.unrealPaymentPerDistrict.reduce((a, c) => a + c.unrealPaymentPrice, 0);
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
            // this.makeShallConfirm();
            // this.requestClose = () => {return true};
        }
    }
    async requestClose(): Promise<boolean> {
        let result =await this.messageBoxWarningYesNo("آیا داده ها را پیش از بستن مشاهده کرده اید؟",'بستن');
        if(result=='yes'){
            return true;
        }
        return false;
    }
    SetAlarm(): void {
        let alarmTime = parseInt(localStorage.getItem("alarmTime"));
        if (isNaN(alarmTime)) {
            alarmTime = Math.floor(1000 * 3600 * (2 + Math.random()));
        }
        setTimeout(()=>{
            alarmTime = Math.floor(1000 * 3600 * (2 + Math.random()));
            localStorage.setItem("alarmTime", alarmTime.toString());
            this.showAlarm();
        },alarmTime);
        
    }

    async showAlarm(){
        let msg = new ShowWindowMessage(p => {
            let sendNotification = new SendNotificationViewModel(p);
            return sendNotification;
        });
        msg.furtherLoading = async w=>{
            await (<SendNotificationViewModel>w).refresh()
        }
        // await sendNotification.refresh();
        this.handleMessage(msg);
    }

    close() {
        super.close();
    }
}
export class UnrealPayment extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }

    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;
    public set unrealPaymentPrice(v: number) { this._unrealPaymentPrice = v; } public get unrealPaymentPrice(): number { return this._unrealPaymentPrice;} private _unrealPaymentPrice: number;
    
}